import { render, staticRenderFns } from "./PanelDetail.vue?vue&type=template&id=66fbd1d8&"
import script from "./PanelDetail.vue?vue&type=script&lang=js&"
export * from "./PanelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports